/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  /**
   * Выпадающий список форм собственности в форме создания юридического лица в личном кабинете
   */
  app.ChoiceOwnershipTypeView = app.View.extend({
    el: '.choice-type-of-ownership',
    run: function () {
      var that = this;
      this.popup = $('.choice-type-of-ownership-popup');
      this.popup_pos = new als.Popup(this.popup, this.$el);
      this.input = this.$('input');
      this.popup_pos.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        function () {
          var leftOffset = that.$el.offset().left,
            topOffset = that.$el.offset().top + that.$el.innerHeight() + 2,
            $body = $('body');
          if (!app.isDesktop) {
            leftOffset = leftOffset - $body.position().left;
            topOffset = topOffset - $body.position().top;
          }
          that.popup.css({
            left: leftOffset,
            top: topOffset
          });
        }
      );
      this.choiceOwnershipTypePopup = new app.ChoiceOwnershipTypePopupView();
      this.model = app.ownershipType = new app.OwnershipType({
        id: this.$el.data('id'),
        name: this.$('.choice-type-of-ownership_active').text()
      });
      this.listenTo(this.model, 'change', this.choiceOwnershipType);
      this.input.on('change', function () {
        var active = that.$('.choice-type-of-ownership_active'),
          value = that.$('input').val();
        if (value !== active.data('id')) {
          var chosen = that.popup.find('.type-of-ownership[data-id=' + value.toString() + ']');
          if (chosen.length) {
            active.data('id', value);
            active.text(chosen.text());
          }
        }
      });
    },
    choiceOwnershipType: function (model) {
      this.model = model;
      this.$('.choice-type-of-ownership_active').data('id', model.get('id'));
      this.$('.choice-type-of-ownership_active').text(model.get('name'));
      this.$('input').val(model.get('id'));
      this.popup_pos.close();
      this.trigger('select');
    }
  });
})(jQuery);

}.call(window));